import { Component, OnInit } from '@angular/core';
import * as highcharts from "highcharts";

@Component({
  selector: 'app-area-range-chart',
  templateUrl: './area-range-chart.component.html',
  styleUrls: ['./area-range-chart.component.scss']
})
export class AreaRangeChartComponent implements OnInit {
  chartOptions = {}
  highcharts = highcharts
  constructor() { }

  ngOnInit(): void {
    this.plotChart();
  }
  plotChart(){
    this.chartOptions = {
      chart: {
        type: "area",
        backgroundColor:"transparent",
        color:'#2A7CF6',
      },
      accessibility: {
        description: "",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        allowDecimals: false,
        labels: {
          // formatter: function () {
          //   return this.value; // clean, unformatted number for year
          // },
        },
        // accessibility: {
        //   rangeDescription: "Range: 1940 to 2018.",
        // },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          // formatter: function () {
          //   return this.value / 1000 + "k";
          // },
        },
      },
      tooltip: {
        pointFormat:
          "{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}",
      },
      plotOptions: {
        area: {
          stacking: 'normal',
          marker: {
            enabled: false,
            symbol: "circle",
            radius: 2,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
        },
      },
      series: [
     
        {
          color: '#D5F9F5',
          
          fillColor: {
            backgroundColor:'#D5F9F5',
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            
            stops: [
              [0, '#D5F9F5'],
              [100,'#D5F9F5']
            ]
            
          },
          data:   [["Jan",16],
          ["Feb",11],
          ["Mar",40],
          ["Apr",50],
          ["May",65],]
        },
      ],
    };
  }

}


